import { useEffect, useState } from 'react';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useParams } from 'react-router-dom';
import { API_PUT_RULE_CONFIGURATION } from '../../constants';
import solutionsStore, { useCurrentSolutionName } from '../../redux';
import { SolutionRuleConfigurationItem } from '../../types/solutionRulesConfiguration';
import SolutionRuleConfigurationEditModal from './SolutionRuleConfigurationEditModal';

type Props = {
  item: SolutionRuleConfigurationItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionRuleConfigurationEditContainer({
  item,
  open,
  onClose,
}: Props) {
  const { solutionId } = useParams();
  const solutionName = useCurrentSolutionName();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);

  const [handleSubmit, loading] = useStatefulApi<SolutionRuleConfigurationItem>(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generateApiPath(API_PUT_RULE_CONFIGURATION, {
          solutionId,
          id: item.id,
        }),
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: `Rule is saved`,
        text: `${item.name} Rule has been modified successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.ruleConfiguration(solutionId);
    }
  );

  return (
    <SolutionRuleConfigurationEditModal
      item={item}
      title={'Edit Rule Configuration'}
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      confirmBtnText={'Save'}
      loading={loading}
    />
  );
}

export default SolutionRuleConfigurationEditContainer;
